import { selectDictResultDetection } from '@src/modules/dictionaries/store'
import { Combobox } from '@src/components'
import { REGISTER_COLUMNS } from '@src/constants'
import { RegisterColumn } from './RegisterColumn'

export class OutcomeColumn extends RegisterColumn {
  static type = REGISTER_COLUMNS.OUTCOME

  constructor (store, settings) {
    const column = {
      header: {
        title: 'Исход',
        component: Combobox,
        props: {
          allowClear: true,
          mode: 'multiple',
          options: selectDictResultDetection(store.getState()).payload?.map(mo => ({
            label: mo.name,
            value: mo.row_code,
            title: mo.name,
          })),
        },
        defaultValue: [],
      },
      width: 300,
      dataIndex: 'outcome',
      dataRender: outcome => outcome ? outcome : '-',
      sort: true,
      nullSearch: true,
    }
    super(column, settings)
  }

  _requestArgs ({ filters, nullSearches }) {
    let requestArgs = []

    if (filters?.outcome && filters?.outcome.length) {
      requestArgs = [{ field: 'outcome_code', value: filters.outcome, operator: '=', invalid: false, cast: 'right-any' }]
    }

    if (nullSearches[this.type]) {
      requestArgs = [{ field: 'outcome_code', operator: '=', value: null, invalid: false }]
    }

    return {
      control: {
        filters: requestArgs,
      },
    }
  }
}
